import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import * as AppConfigModule from '../../../config-loader';
import { GeneralHelpers } from '../helpers/general.helper';

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  const oauthService = inject(OAuthService);

  // Skip token injection for certain URLs
  if (shouldSkipRequest(req.url)) {
    return next(req);
  }

  // Check for skip header
  const skipHeader = GeneralHelpers.getInterceptorSkipHeader();

  if (req.headers.has(skipHeader)) {
    const headers = req.headers.delete(skipHeader);

    return next(req.clone({ headers }));
  }

  // Get access token from OAuthService (changed from ID token to access token)
  const token = oauthService.hasValidAccessToken() ? oauthService.getAccessToken() : null;

  // Add token only if it exists
  if (token) {
    const authReq = req.clone({
      headers: req.headers.set('Authorization', `Bearer ${token}`)
    });
    return next(authReq);
  }

  return next(req);
};

function shouldSkipRequest(url: string): boolean {
  const environment = AppConfigModule.appConfig.env;
  const issuerUrl = environment.auth.zitadel.issuer;

  // Skip requests to OAuth endpoints
  if (url.startsWith(issuerUrl)) {
    return true;
  }

  // Skip Sentry requests
  if (url.includes('sentry')) {
    return true;
  }

  // Skip requests to well-known endpoints
  if (url.includes('.well-known/openid-configuration')) {
    return true;
  }

  // Skip requests to token endpoints
  if (
    url.includes('/token') ||
    url.includes('/oauth/token') ||
    url.includes('/oauth2/token')
  ) {
    return true;
  }

  // Skip userinfo endpoint requests
  if (url.includes('/userinfo')) {
    return true;
  }

  // Skip JWKS endpoints
  if (url.includes('/jwks') || url.includes('/keys')) {
    return true;
  }

  return false;
}
